import { connect } from 'react-redux';
import { updateIsSideBarOpen } from 'ducks/meta';
import AppLayout from './AppLayout';

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    userId: state.auth.userId,
    profileName: state.auth.fullName,
    localisation: state.localisation,
    isSideBarOpen: state.meta.isSideBarOpen,
    featureFlags: state.featureFlags,
  };
};

const mapDispatchToProps = {
  updateIsSideBarOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
